export const LAST_FRAME = 225;

export const calculatePercentageByFrame = (currentFrame: number): number => {
  if (currentFrame > LAST_FRAME) {
    return 100;
  } else {
    return Math.floor((currentFrame / LAST_FRAME) * 100);
  }
};
